<template>
  <div class="row">
    <div class="col-md-6 offset-md-3">
      <Section title="Zaloguj się">
        <b-form novalidate>
          <Alert variant="danger" :show="errorMessage.length">
            {{ errorMessage }}
          </Alert>
          <form-wrapper :validator="$v.login">
            <div style="min-height: 120px">
              <form-group name="username">
                <InputControl
                  id="username"
                  v-model="login.username"
                  label="Adres e-mail"
                  :inline="false"
                  :label-class="labelClass"
                  :control-class="controlClass"
                  :description-class="descriptionClass"
                />
              </form-group>

              <form-group name="password">
                <InputControl
                  id="password"
                  v-model="login.password"
                  label="Hasło"
                  type="password"
                  :allow-all-caps="true"
                  :inline="false"
                  :label-class="labelClass"
                  :control-class="controlClass"
                  :description-class="descriptionClass"
                />
              </form-group>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <btn
                  class="mb-2"
                  variant="primary"
                  icon="unlock"
                  title="Zaloguj się"
                  :disabled="isSending || isSent"
                  disabled-icon="polmed"
                  disabled-title="Loguję"
                  @click="submit"
                />
                <br />
                <btn
                  variant="link"
                  title="Nie pamiętam hasła"
                  @click="$router.push('forgotten-password')"
                />
              </div>
            </div>
          </form-wrapper>
        </b-form>
      </Section>

      <Section v-if="!isAdminMode" title="Załóż konto">
        <p class="text-center">
          <btn
            variant="primary"
            icon="user-plus"
            title="Załóż konto w systemie"
            @click="$router.push('account')"
          />
        </p>
      </Section>
    </div>
  </div>
</template>

<script>
import BaseForm from "@/components/Base/Form/BaseForm";
import InputControl from "@/components/Controls/InputControl";

import validations from "./validations";

import { mapGetters } from "vuex";

export default {
  name: "UserLoginForm",
  components: {
    InputControl
  },
  extends: BaseForm,
  validations,
  data() {
    return {
      formUrl: `${process.env.VUE_APP_XHR_ROOT}/user/login/`,
      labelClass: "col-form-label col-md-3 form__label",
      controlClass: "col-md-9 form__control",
      descriptionClass: "offset-md-3 col-md-9 form__control-description",
      login: {
        username: "",
        password: ""
      },
      formName: "login"
    };
  },

  computed: {
    ...mapGetters("App", ["isAdminMode", "isUserMode"])
  },

  created() {
    this.getUser();
  },

  methods: {
    afterSubmit(res) {
      if (res.data.success) {
        this.$router.push("/");
      }
    },
    getUser() {
      // this.$store.dispatch("User/getCurrent", true).then(() => {
      //   if (this.$store.state.User.user.id) {
      //   }
      // });
    }
  }
};
</script>
